import { render, staticRenderFns } from "./ModalDeleteProd.vue?vue&type=template&id=10d6e961"
import script from "./ModalDeleteProd.vue?vue&type=script&lang=js"
export * from "./ModalDeleteProd.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteProd.vue?vue&type=style&index=0&id=10d6e961&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports